import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    const breadcrumbItems = [
        { name: "Dashboard", path: "/admin/admin-dashboard" },
        { name: "Content / Magazine Management", path: "/admin/magazine-management" },
        { name: "Content / Article Management", path: "/admin/article-management" },
        { name: "Management / User Management", path: "/admin/user-management" },
        { name: "Content / Magazine Management / Edit Magazine", path: "/admin/edit-magazine" },
        { name: "Profile", path: "/admin/admin-profile" },
        { name: "Profile / Edit Profile", path: "/admin/admin-edit-profile" },
        { name: "Content / Feed Article Management", path: "/admin/rss-management" },
        { name: "Content / Feed Article Management / Add New Post", path: "/admin/add-rsspost" },
        { name: "Content / Feed Article Management / Edit Post", path: "/admin/edit-rsspost" },
        { name: "Content / Magazine Management / Add New Magazine", path: "/admin/add-magazine" },
        { name: "Content / Article Management / Add New Post", path: "/admin/add-post" },
        { name: "Content / Article Management / Edit Post", path: "/admin/edit-post" },
        { name: "Management / Ads Management", path: "/admin/ad-management" },
        { name: "Management / User Management / Add User", path: "/admin/user/adduser" },
        { name: "Management / User Management / Edit User", path: "/admin/user/edit" },
        { name: "Management / Notification Management", path: "/admin/notification-management" },
        { name: "Content / Category Management", path: "/admin/category-management" },
        { name: "Content / Sub Category Management", path: "/admin/sub-category-management" },
        { name: "Settings", path: "/admin/settings" },
        { name: "Management / Subscription Management", path: "/admin/subscription" },
        { name: "Content / Comments Management", path: "/admin/comments-management" },
        { name: "Genealogy Tree", path: "/admin/genealogy-tree" },
        { name: "Finance / E-wallet", path: "/admin/admin-ewallet" },
        { name: "Finance / Payout", path: "/admin/admin-payout" },
        { name: "Content / Home Page Left & Right Setting", path: "/admin/homepage-settings" },
        { name: "Content / Today Highlight & Trending Setting", path: "/admin/highlight-settings" },
        { name: "Content / Today Highlight & Trending Setting / Add Highlight Article", path: "/admin/add-highlight" },
        { name: "Content / Today Highlight & Trending Setting / Edit Highlight Article", path: "/admin/edit-highlight" },
        { name: "Content / Home Page Left & Right Setting / Edit Top Article", path: "/admin/edit-articlesettings" },
    ];

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {pathnames.map((pathname, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const breadcrumb = breadcrumbItems.find((b) => b.path === to);

                    if (!breadcrumb) return null;

                    const breadcrumbParts = breadcrumb.name.split(" / ");

                    return (
                        <li
                            key={to}
                            className={`breadcrumb-item ${index === pathnames.length - 1 ? "active" : ""}`}
                            aria-current={index === pathnames.length - 1 ? "page" : undefined}
                        >
                            {breadcrumbParts.map((part, partIndex) => {
                                const partPath = breadcrumbParts.slice(0, partIndex + 1).join(" / ");
                                const partLink = breadcrumbItems.find((b) => b.name === partPath)?.path;

                                const isEditPage = partLink?.includes("edit");
                                const isCurrentPage = partLink === location.pathname;

                                return (
                                    <>
                                        <span key={partIndex}>
                                            {index === pathnames.length - 1 && partIndex === breadcrumbParts.length - 1 ? (
                                                isEditPage && isCurrentPage ? (
                                                    part
                                                ) : (
                                                    part
                                                )
                                            ) : partLink && !isEditPage ? (
                                                <Link to={partLink}>{part}</Link>
                                            ) : (
                                                part
                                            )}
                                        </span>
                                        {partIndex < breadcrumbParts.length - 1 && " / "}
                                    </>
                                );
                            })}
                        </li>
                    );
                })}
            </ol>
            <style jsx>
                {`
                    .breadcrumb {
                        display: flex;
                        flex-wrap: nowrap;
                        padding: 0;
                        margin-bottom: 1rem;
                        list-style: none;
                    }

                    .breadcrumb-item {
                        display: flex;
                    }

                    .breadcrumb-item + .breadcrumb-item::before {
                        content: "/";
                        padding: 0 0.5rem;
                        color: #6c757d;
                    }

                    .breadcrumb-item a {
                        color: #007bff;
                        text-decoration: none;
                    }

                    .breadcrumb-item a:hover {
                        text-decoration: underline;
                    }

                    ol li {
                        width: unset !important;
                    }

                    .breadcrumb-item.active {
                        color: #6c757d;
                    }
                `}
            </style>
        </nav>
    );
};

export default Breadcrumb;
